var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';
 let { directions_link, isPhone, isDesktop, hasStreetView, photos, property, leadSubmitted, closeMapLeadStatus } = options; 
__p+='\n\n';
 if (!isPhone) { 
__p+='\n  <div class="component_qv-map-container hide component_qv-fullmap float-left js-qv-amenities-map-wrapper " id="full-map">\n    ';
 if (property.display_request_more_details_form && !closeMapLeadStatus && isDesktop) { 
__p+='\n      <div class="qv-fullmap-leftcontent">\n        <div class="qv-fullmap-imgwrapper">\n          <div class="qv-fullmap-lead-toggle" id="qv-fullmap-lead-toggle"><i class="ra ra-close-thin"></i></div>\n          ';
 if (photos.length){ 
__p+='\n            <img src="'+
((__t=( photos[0].url.replace('xd-w640_h480_q80', 'xd-w480_h480_q80') ))==null?'':__t)+
'" alt="'+
((__t=( property.full_address_display ))==null?'':__t)+
'" title="'+
((__t=( property.full_address_display ))==null?'':__t)+
'">\n            ';
 } else { 
__p+='\n            <div class="coming-soon-img"></div>\n          ';
 } 
__p+='\n        </div>\n        <div class="qv-fullmap-leadwrapper">\n            <div id="aj-qv-fullmap-leadform"></div>\n        </div>\n      </div>\n    ';
 } 
__p+='\n\n  <div id="component-qv-map-wrapper" class="component_qv-map-wrapper '+
((__t=( property.display_request_more_details_form && !closeMapLeadStatus && isDesktop ? 'offset-mapwrapper' : '' ))==null?'':__t)+
'">\n    <div id="qv-fullmap" class="component_qv-map map-main-container qv-amenities-map '+
((__t=( directions_link ? 'offset-layers-right' : '' ))==null?'':__t)+
'"></div>\n      ';
 if (directions_link) { 
__p+='\n      <a class="get-directions" href="'+
((__t=( directions_link ))==null?'':__t)+
'" target="_blank" data-omtag="ldp:map:get-directions">Directions</a>\n    ';
 } 
__p+='\n      <div class="map-controllers text-center" id="view-controllers">\n      ';
 if (hasStreetView) { 
__p+='\n        <a class="btn-map-rdc change-view street-view" data-omtag="ldp:slideshow:street">\n          <span>Street View<span>\n        </a>\n      ';
 } 
__p+='\n      <a class="btn-map-rdc change-view map-view hide" data-omtag="ldp:slideshow:map">\n        <span>Map View</span>\n      </a>\n    </div>\n    <div class="map-attributions">\n      <div class="ldp-amenity-map-attribution amenities-sponsor">\n          <span class="pull-left font-size-small attribution-text yelp hide-attribution">Powered by</span>\n          <span class="pull-left yelp hide-attribution yelp-logo with-logo"></span>\n          <span class="no-show" id="tracking-url"></span>\n      </div>\n      <div class="qv-map-crime-sponsor hide-attribution">\n        <div class="js-crime font-size-small">\n          Data Provided by\n          <a href="https://www.locationinc.com" target="_blank" rel="nofollow">Location Inc.</a>\n        </div>\n      </div>\n      <div class="qv-map-school-sponsor hide-attribution">\n        <div class="js-school font-size-small">\n          Powered by\n          <a href="//www.greatschools.org" target="_blank" rel="nofollow">GreatSchools</a>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  </div>\n';
 } 
__p+='\n';
return __p;
};



// WEBPACK FOOTER //
// ./quick_view/templates/maps/fullmap.jst.ejs